import { useEffect } from 'react'
import { LabelKV } from '../helpers/labels'
import { formatTeamNameForDeploy } from '../helpers/teamFormatter'

export function useReviewPersistence(params: {
  businessData: any;
  finalServiceDeps: { name: string; repoName: string; branch: string }[];
  finalInfraDeps: { name: string; branch: string }[];
  bulkResults: any[];
  branchMapping: Record<string, string>;
  deployTagMapping: Record<string, string>;
  selectedBusinessUnits: string[];
  deploymentBranch: string;
  deployRepoBranch: string;
  applicationBranch: string;
  team: string;
  namespace: string;
  location: string;
  buildRailsEnv: string;
  standalone: boolean;
  envClass: string;
  lastBuiltImage: boolean;
  downmergeMaster: boolean;
  extraEnvVars: string[];
  enableNewRelic: boolean;
  enableRegressionProfile: boolean;
  labelsByApp: Record<string, { found: { name: string; value: string }[] }>;
  storedLabelsInfo: Record<string, { requiredLabels: Record<string, boolean>; found: LabelKV[] }>;
}) {
  const {
    businessData,
    finalServiceDeps,
    finalInfraDeps,
    bulkResults,
    branchMapping,
    deployTagMapping,
    selectedBusinessUnits,
    deploymentBranch,
    deployRepoBranch,
    applicationBranch,
    team,
    namespace,
    location,
    buildRailsEnv,
    standalone,
    envClass,
    lastBuiltImage,
    extraEnvVars,
    downmergeMaster,
    enableNewRelic,
    enableRegressionProfile,
    labelsByApp,
    storedLabelsInfo,
  } = params

  useEffect(() => {
    if (!businessData?.releases) return

    const step2Raw = localStorage.getItem('step2Selections')
    let step2Selections: { selectedBusinessUnits: string[]; selectedDependencies: { name: string }[] } | null = null
    try { step2Selections = step2Raw ? JSON.parse(step2Raw) : null } catch {}

    const allDeps = [...finalServiceDeps, ...finalInfraDeps]
    const selectedDependencies = (step2Selections?.selectedDependencies?.length
      ? step2Selections.selectedDependencies
      : allDeps.map((dep) => {
        const rel = businessData.releases.find((r: any) => r.name === dep.name)
        if (rel && rel.type === 'infrastructure') {
          return {
            name: dep.name,
            branch: branchMapping[dep.name] || deploymentBranch,
            deployTag: branchMapping[dep.name] || deploymentBranch,
          }
        } else {
          return {
            name: dep.name,
            branch: branchMapping[dep.name] || applicationBranch,
            deployTag: deployTagMapping[dep.name] ? deployTagMapping[dep.name] : '',
          }
        }
      })) as any

    const reviewData = {
      selectedBusinessUnits: step2Selections?.selectedBusinessUnits ?? selectedBusinessUnits,
      selectedDependencies,
      deployBranch: deploymentBranch,
      deployRepoBranch,
      applicationBranch,
      team: team ? formatTeamNameForDeploy(team) : team, // Format team name for deploy container
      namespace,
      location,
      buildRailsEnv,
      standalone,
      envClass,
      lastBuiltImage,
      downmergeMaster,
      extraEnvVars,
      enableNewRelic,
      enableRegressionProfile,
      storedLabelsInfo,
    }
    localStorage.setItem('reviewData', JSON.stringify(reviewData))
    localStorage.removeItem('step2Selections')
  }, [
    finalServiceDeps,
    finalInfraDeps,
    bulkResults,
    branchMapping,
    deployTagMapping,
    selectedBusinessUnits,
    deploymentBranch,
    deployRepoBranch,
    applicationBranch,
    team,
    namespace,
    location,
    buildRailsEnv,
    standalone,
    envClass,
    lastBuiltImage,
    extraEnvVars,
    downmergeMaster,
    enableNewRelic,
    enableRegressionProfile,
    businessData,
    storedLabelsInfo,
  ])
}
